<template>
    <setup_content v-if="active_step == 'reference_step2'" title="Определение кадастровой стоимости типового (эталонного) объекта недвижимости">
        <template v-slot:buttons>
            <div class="d-flex justify-content-center mb-2" style="gap: .625rem;">
                <b-button v-if="calc_type === 'Метод сравнения продаж'"
                    variant="outline-primary-secondary"
                    @click="() => $emit('set_active_step', 'reference_step2_1')"
                >
                    <span>{{ controller.not_editable ? "Настройки расчета" : "Настроить расчет" }}</span><base-icon name="settings" size="md" />
                </b-button>
            </div>
        </template>

        <div class="element-row mb-3">
            <label class="element-row_label">Выберите способ расчета</label>
            <div class="element-row_fields">
                <b-form-radio-group stacked
                    v-model="calc_type" :options="options"
                    :disabled="!controller.check_roles([ 'model' ])"
                />
                </div>
        </div>

        <element_row
            v-if="calc_type === 'Данные пользователя'"
            title="Удельный показатель кадастровой стоимости типового (эталонного) объекта недвижимости"
            :data="controller.data.calc_custom_UPKS"
            v-on:set_value="(key, value) => controller.set_field(`calc_custom_UPKS.${key}`, value)"
            :validation="validation"
            :readonly="!controller.check_roles([ 'model' ]) || controller.not_editable"
        />
    </setup_content>

    <sales v-else-if="active_step == 'reference_step2_1'" :controller="controller" />
</template>

<script>
import api from "../../../../../../api";
import setup_content from "../../setup_assets/content"
import element_row from "../../../../../widgets/element-row"
import sales from "./sales";
import Reference_controller from "../controller";

export default {
    props :
	{
        controller : Reference_controller,
        active_step : String,
	},

    components :
    {
        setup_content,
        element_row,
        sales
    },

    data()
    {
        return {
            calc_type : this.controller.data.calc_type,

            options: [ 'Метод сравнения продаж', 'Данные пользователя' ],
            validation: {
                check: (value) => api.check_number({ value, accuracy : 2, gt : 0 }),
                msg: "Больше 0, до 2-х знаков после запятой"
            }
        }
    },

    watch :
    {
        calc_type(value)
        {
            this.controller.set_field("calc_type", value)
        }
    },
}
</script>
